// A quote taken into a conversation's reply box (a card's Reply, or text selected in a
// reply), after anything already written, so several quotes build one message.
import { type Dispatch, type RefObject, type SetStateAction, useCallback } from "react";

export const useComposerQuote = (
  setMessage: Dispatch<SetStateAction<string>>,
  box: RefObject<HTMLTextAreaElement>,
): ((quote: string) => void) =>
  useCallback(
    (quote: string) => {
      setMessage((prev) => (prev.trim() ? `${prev.trimEnd()}\n\n${quote}` : quote));
      box.current?.focus();
    },
    [setMessage, box],
  );
